import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import TreeLevel from './components/TreeLevel';
import { Button, Grid, Tooltip, Typography } from '@material-ui/core';
import { getFormattedDates, updateDates } from '../../treeComponents/helper';
import './CoursePlanTree.css';
import { AddContent } from '../../MyLibrary';
import { contentManagementAction } from '../../../reducers/contentMangementData';
import { handleContentSelect, handleAddContent, deleteDeSelectedData } from './helpers/handleAllMyLibraryEvents';
import { preSelectedFilter } from './utils/preFilters';
import { setContentFilter } from './helpers/setFilters';
import { conceptMapping, mappingWithHash } from './helpers/conceptMapping';
import Spinner from './helpers/Spinner';
import { contentManagementService } from '../../../service';
import courseService from '../../../../mylibrary/services/courseService';
import { WithStyles, withStyles } from '@material-ui/core';
import { coursePlanStyle } from '../../../styles';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import { AddScheduledTest, AddScheduledTestPopUp } from '../addTestDialog';
import { CourseTypes } from '../../../types/enums/CourseTypes';
import courseManagementServices from '../../../service/courseManagementServices';
import { Template, TestDetail } from '../../../types/interfaces/CourseBasicDetails';
import TestComponent from '../../treeComponents/component/TestComponent';
import dateService, { convertDateToUTC } from '../../../../common/services/dateService';
import { createErrorSheet } from '../../../helpers/helpers';
import { showMsg } from '../../../../../components/course/actions/loaderAlert';
import { AddNewMilestone } from '../../treeComponents/component';
import { getTestTypeByActiveRadio } from './helpers/getTestTypeByActiveRadio';
import { checkForDuplicateTests, checkForDuplicateTestsWithinSheet } from '../addTestDialog/helpers/checkAddedTest';
import { MyPATDialog } from '../../../../common';
import MoveChapter from './MoveChapter';
import { isLastInstanceOfChapter, checkForDuplicateChapters } from '../../treeComponents/component/helpers/isLastInstanceOfChapter';
import CourseSettingPopUp from './components/CourseSettingPopUp';
// import CourseSettingPopUp from '../../CourseSettingPopUp';

interface CoursePlanTreeProps extends WithStyles<typeof coursePlanStyle> {
  handleCourseComponent?: Function;
  structure: object[];
  treeData: any;
  coursePackageList: any;
  setTreeData: Function;
  getPackageByIdData: any;
  match: any;
  filterSelectedQuestion: any;
  setFilterSelectedQuestion: Function;
  classes: any;
  fromCombo?: boolean;
  addMilestoneTestInPhase: (data: { phaseId: string; mileStoneTestData: any }) => void;
  setTestSeries: Function;
  setBulkUploadTestData: Function;
  showMsg: any;
  includesScheduledTests: boolean;
  setIncludesScheduledTests: Function;
  setConceptChapterPopup: Function;
  bulkDrag: any;
  moveData: Function;
  setBulkDrag: Function;
  resetBulkDrag: Function;
  setGoalsDriller:Function;
}

interface CoursePlanTreeStates {
  openMyLibrary: boolean;
  selectedQuestionCount: number;
  preFilters: any;
  selectedQuestion: any;
  subjectSelection: string;
  mappedConceptsAndChapter: any;
  templates: Template[];
  showBulkTestPopUp: boolean;
  activeRadio: string;
  openAST: boolean;
  loading: boolean;
  tempQuestions: any;
  prevSelectedQuestion: any;
  selectAllCount: number;
  showConceptChapterPopup: boolean;
  selectedContentType: string;
  showFooterMoveBtn: boolean;
  openMoveToDialog: boolean;
  openDeleteDialog:boolean;
  dataToMove: any;
  destinationWeek: any;
  onlyMovingChapters: boolean;
  onlyMovingConcepts: boolean;
  movingChaptersAndConcepts: boolean;
  treeDataForDelete: any;
  openRequestPop: boolean,
}
const initialCoursePlanStates = {
  openMyLibrary: false,
  selectedQuestion: [],
  selectedQuestionCount: 0,
  preFilters: preSelectedFilter,
  subjectSelection: 'All Subjects',
  mappedConceptsAndChapter: new Map(),
  templates: [],
  loading: true,
  showBulkTestPopUp: false,
  activeRadio: '',
  openAST: false,
  tempQuestions: [],
  prevSelectedQuestion: [],
  selectAllCount: 0,
  showConceptChapterPopup: false,
  selectedContentType: '',
  showFooterMoveBtn: false,
  openMoveToDialog: false,
  dataToMove: [],
  destinationWeek: {
    phase: '',
    week: ''
  },
  onlyMovingChapters: false,
  onlyMovingConcepts: false,
  movingChaptersAndConcepts: false,
  treeDataForDelete: {},
  openDeleteDialog:false
}
class CoursePlanTree extends PureComponent<CoursePlanTreeProps, CoursePlanTreeStates> {
  constructor(props: CoursePlanTreeProps) {
    super(props);
    this.state = {
      ...initialCoursePlanStates,openRequestPop: false,
    };
  }
  componentDidMount = () => {
    setTimeout(() => {
      const { treeData } = this.props;

      let data = checkForDuplicateChapters(treeData);
      this.props.moveData(data);

      this.setState({
        treeDataForDelete: treeData
      })
      this.loadContentFilter();
      if (Object.keys(treeData).length) {
        this.setState({ loading: false });
      }
    }, 1500);
  };

  loadContentFilter = () => {
    const { getPackageByIdData, treeData,setGoalsDriller } = this.props;
    const { preFilters } = this.state;
    const { courseDetails = [], contentPreferences } = getPackageByIdData;
    if (contentPreferences.scheduledTests) { this.props.setIncludesScheduledTests(contentPreferences.scheduledTests.enabled || false); }
    this.setTemplates(courseDetails);
    contentManagementService.getCourseDetails(courseDetails[0].courseId).then((courseData: any) => {
      const { courseType = {} } = courseData;
      courseService.list().then((goalsList: any) => {
        const goalsDriller=setContentFilter(goalsList, courseType, preFilters, getPackageByIdData, this.handleSetState);
        // conceptMapping(treeData, this.handleSetState);
        setGoalsDriller(goalsDriller);
        mappingWithHash(treeData, this.handleSetState);
        this.setInitialFilterData(treeData);
      });
    });
  }

  componentDidUpdate = (prevProps: CoursePlanTreeProps) => {
    if (JSON.stringify(prevProps.filterSelectedQuestion) !== JSON.stringify(this.props.filterSelectedQuestion)) {
      this.loadFilterContent();
    }
    if (!_.isEqual(prevProps.getPackageByIdData, this.props.getPackageByIdData)) {
      this.loadContentFilter();
    }
    if(prevProps.bulkDrag !== this.props.bulkDrag){
      this.checkBulkDragToMakeMoveVisible(this.props.bulkDrag)
    }
  };

  checkBulkDragToMakeMoveVisible = (bulkDrag: any) => {
    const keysOfData = Object.keys(bulkDrag);
    const movableTypes = this.checkMovableType(keysOfData);
    const {
      movingChaptersAndConcepts,
      movingOnlyChapters,
      movingOnlyConcepts
    } = movableTypes;
    const len = keysOfData.length;
    let canShowMoveBtn = false;
    let movableData = []
    if(len > 0) {
      for(let i = 0 ; i < len; i++){
        let isDataMarkedToMove = bulkDrag[keysOfData[i]];
        if(isDataMarkedToMove){
          movableData.push(keysOfData[i])
          canShowMoveBtn = true
        }
      }
    }

    this.setState({
      showFooterMoveBtn: canShowMoveBtn,
      dataToMove: movableData,
      onlyMovingChapters: movingOnlyChapters,
      onlyMovingConcepts: movingOnlyConcepts,
      movingChaptersAndConcepts: movingChaptersAndConcepts
    })
  }

  checkMovableType = (keys:any[]) => {
    let movingOnlyChapters = false;
    let movingOnlyConcepts = false;
    let movingChaptersAndConcepts = false;
    let types = []
    for(let i = 0; i < keys.length ; i++){
      let currentKey = keys[i];
      const type = currentKey.split('-')[0];
      types.push(type);
    }
    if(types.includes('chapter') && types.includes('concept')){
      movingChaptersAndConcepts = true;
    }

    if(!types.includes('concept')){
      movingOnlyChapters = true;
    }

    if(!types.includes('chapter')){
      movingOnlyConcepts = true;
    }

    return {
      movingChaptersAndConcepts: movingChaptersAndConcepts,
      movingOnlyChapters: movingOnlyChapters,
      movingOnlyConcepts: movingOnlyConcepts
    }

  }

  toggleOpenMoveToDialog = () => {
    const { openMoveToDialog } = this.state;
    this.setState({
      openMoveToDialog: !openMoveToDialog
    })
  }
  toggleOpenDeleteToDialog = () => {
    const { openDeleteDialog } = this.state;
    this.setState({
      openDeleteDialog: !openDeleteDialog
    })
  }
  checkForDuplicateCourse = () => {
    let findDuplicate = this.props.coursePackageList.filter((packageEle: any) => packageEle._id === this.props.treeData.packageId)
    if(findDuplicate && findDuplicate[0] && findDuplicate[0].copiedFromPackageId) {
      return true;
    }
    return false
  }
  setInitialFilterData = (treeData: any) => {
    let cloneTreeData = JSON.parse(JSON.stringify(treeData));
    const { phases = [] } = cloneTreeData;
    let contentData: any = [];
    phases &&
      phases.length &&
      phases.forEach((phase: any) => {
        const { weeks = [] } = phase;
        weeks &&
          weeks.length &&
          weeks.forEach((week: any) => {
            const { subjects = [] } = week;
            subjects &&
              subjects.length &&
              subjects.forEach((subject: any) => {
                const { chapters = [] } = subject;
                chapters &&
                  chapters.length &&
                  chapters.forEach((chapter: any) => {
                    const { content = [], concepts = [] } = chapter;
                    content &&
                      content.length &&
                      content.forEach((cont: any) => {
                        contentData.push(cont);
                      });
                    concepts &&
                      concepts.length &&
                      concepts.forEach((concept: any) => {
                        const { content = [] } = concept;
                        content &&
                          content.length &&
                          content.forEach((cont: any) => {
                            contentData.push(cont);
                          });
                      });
                  });
              });
          });
      });
    // this.setState({
    //   selectedQuestionCount: contentData.length
    // })
    this.handleSelectedFilterQuestion(contentData);
  };



  setTemplates = (courseDetails: any[]) => {
    const goals = _.map(courseDetails, 'courseId').join(',');
    if (_.isEmpty(goals)) return;
    let queryParams: any = {
      type : CourseTypes.standard,
      goals :goals,
      pagination:false };
    
    // queryParams.pageSize = 51; 
    courseManagementServices.getPackageTemplates(queryParams).then((response: any) => {
      const { responseObject = {} } = response;
      const packages = _.get(responseObject, 'packages', []);
      this.setState({ templates: packages });
    });
  };

  toggleMyLibraryData = () => {
    this.setState((prevState: any) => ({
      openMyLibrary: !prevState.openMyLibrary,
    }));
  };
  finalSelection = () => {
   
    const{preFilters}=this.state;
    const modifyFilter=JSON.parse(JSON.stringify(preFilters));
    if(this.state.selectedContentType){ 
			let subFilters = _.get(modifyFilter,"contentFilterData[0].filters[1].filters",[]);
			if (this.state.selectedContentType === 'chapter'&&subFilters.length>0) {
				let newFilter = [];
				for (let i = 0; i < subFilters.length; i++) {
					if (subFilters[i].filterValue === 'chap') {
						newFilter.push(subFilters[i]);
					}
				}
				modifyFilter.contentFilterData[0].filters[1].filters = newFilter;
			} else if (this.state.selectedContentType === 'concept'&&subFilters.length>0) {
				let newFilter = [];
				for (let i = 0; i < subFilters.length; i++) {
					if (subFilters[i].filterValue === 'concept') {
						newFilter.push(subFilters[i]);
					}
				}
				modifyFilter.contentFilterData[0].filters[1].filters = newFilter;
		  	}
		  }
    this.setState((prevState: any) => ({
      openMyLibrary: true,
      preFilters,modifyFilter
      // showConceptChapterPopup:false
    }));
  }

  onRadioButtonChange = (e: any) => { 
    this.setState({selectedContentType: e.currentTarget.value})
  }
  handleContentSelectFromLibrary = (content: any, totalCount?: number) => {
    const contentLength = totalCount || content.length;
    this.setState({
      selectedQuestion: [...content] || []
    }, () => handleContentSelect(content, contentLength, this.handleSetState));
  };
  handleSetState = (updatedStateValues: any) => {
    this.setState((prevState) => ({
      ...prevState,
      ...updatedStateValues,
    }));
  };

  getAllSelectCount = (count: number) => {
   this.setState({
    selectAllCount: count
   });
  }

  handleAddContentFromLibrary = () => {
    const { setTreeData, showMsg, treeData, getPackageByIdData } = this.props;
    const { selectedQuestion, mappedConceptsAndChapter, tempQuestions,selectedContentType } = this.state;
    let contents = JSON.parse(JSON.stringify(selectedQuestion));
    handleAddContent({ contents, treeData, setTreeData, mappedConceptsAndChapter,level:selectedContentType }, this.handleSelectedFilterQuestion);
    this.handleSetState({
      tempQuestions: [],
      selectedQuestionCount: 0,
    });
  };

  getContentType = (type: string) => {
    switch (type) {
      case 'studyNotes':
        return 'note';
      case 'video':
        return 'videos';
      case 'formula':
        return 'formulas';
      case 'test':
        return 'testpapers';
    }
  };

  setIdFormodifiedData = (data: any) => {
    let cloneData = JSON.parse(JSON.stringify(data));
    const _id = `${data.id}${this.getContentType(data.type)}`;
    cloneData._id = _id;
    return cloneData;
  }
  modifySelectedData = (data: any) => {
    let newData: any = [];
    if (data && data.length) {
      data.forEach((ele: any) => {
        if (ele.hasOwnProperty('id')) {
          newData.push(this.setIdFormodifiedData(ele))
        } else {
          newData.push(ele);
        }
      });
    }
    return newData;
  }
  getExcludedIds = (content: any) => {
    let set: any = new Set([]);
    content && content.length && content.forEach((ele: any) => {
      set.add(ele.content_Id || ele.id)
    });
    return Array.from(set);
  }

  removeDuplicateContent = (filterContent: any) => {
    const data = filterContent.filter((v: any, i: any, a: any) => a.findIndex((t: any) => (t.id === v.id)) === i)
    return data;
  }
  addIdToContent = (content: any) => {
    let data: any = [];
    content && content.forEach((ele: any) => {
      if (ele.content_Id) {
        data.push({ ele, id: ele.content_Id })
      }
      else {
        data.push(ele);
      }
    });
    return data;
  }
  loadFilterContent = () => {
    const { filterSelectedQuestion } = this.props;
    let newFilteredContent = [...filterSelectedQuestion];
    const getIds = this.getExcludedIds(newFilteredContent);
    this.setPreSelectedIds(getIds);
  }
  handleSelectedFilterQuestion = (content: any) => {
    const { filterSelectedQuestion, setFilterSelectedQuestion } = this.props;
    let contentData = this.addIdToContent([...content]);
    if (content && content.length) {

      let newFilteredContent = [...filterSelectedQuestion, ...contentData];
      const getIds = this.getExcludedIds(newFilteredContent);
      this.setPreSelectedIds(getIds);
      const removedDuplicateData = this.removeDuplicateContent(newFilteredContent)
      setFilterSelectedQuestion({
        filterSelectedQuestion: [...JSON.parse(JSON.stringify(removedDuplicateData))],
      });
    }
  };
  setPreSelectedIds = (id: any) => {
    this.setState({
      preFilters: { ...this.state.preFilters, excludedIds: id }
    });
  }

  onCheckContentExist = (id: string) => {
    const { filterSelectedQuestion } = this.props;
    let check = false;
    if (filterSelectedQuestion && filterSelectedQuestion.length) {
      check = filterSelectedQuestion.find((ele: any) => (ele.id === id || ele.content_Id === id))
    }
    // return check ? true: false
    return false;
  }
  handleRemoveFilterQuestion = (content: any) => {
    const { filterSelectedQuestion, setFilterSelectedQuestion } = this.props;
    let newFilteredQuestion = filterSelectedQuestion.filter((element: any) => element.id !== content.content_Id);
    setFilterSelectedQuestion({
      filterSelectedQuestion: [...JSON.parse(JSON.stringify(newFilteredQuestion))],
    });
  };

  handleMilestoneTestAdd = (data: any, phaseId: string) => {
    this.props.addMilestoneTestInPhase({ phaseId, mileStoneTestData: data });
  };

  handleBulkTestBttn = () => {
    this.setState({
      showBulkTestPopUp: !this.state.showBulkTestPopUp,
    });
  };

  validateTestIds = async (tests: Array<any>, testType: string) => {
    const { getPackageByIdData: packageData } = this.props;
    const { _id: packageId } = packageData;
    const reqParams = {
      tests: tests,
      courseId: _.get(packageData, 'courseDetails[0].courseId', ''),
      packageId: packageId,
      testType: testType
    };
    try {
      const res = await courseManagementServices.validateTestIds(reqParams);
      return res;
    } catch (err) { }
  };

  createTestNameAndIdMap = (validTests: any) => {
    const testNameIdMap: any = {};
    validTests.map((test: any) => {
      const { testId, _id } = test;
      testNameIdMap[testId] = _id;
    });
    return testNameIdMap;
  };

  getQuestionCount = (test:any, validTests: any[]) => {
    let questionsCount;
    for(let i = 0; i < validTests.length; i++){
      if(validTests[i].testId === test.testId)
      {
        questionsCount = validTests[i].questionsCount;
        break;
      }
    }
    return questionsCount;
  }

  handleAddTests = async (testIdsToCheck: any, testDetails: TestDetail[], activeRadio: any) => {
    const testType = getTestTypeByActiveRadio(activeRadio) || '';
    const res = await this.validateTestIds(testDetails, testType);
    const validTests = _.get(res, 'validTests', []);
    
    const inValidTests = _.get(res, 'invalidTests', []);
    if (inValidTests.length == 0) {
      const testNameIdMap = this.createTestNameAndIdMap(validTests); // CHECK testNameIdMap
      
      const { treeData: coursePlan } = this.props;
      const { getPackageByIdData: packageData } = this.props;
      const newCoursePlan = { ...coursePlan };
      const newTestSeries = [...newCoursePlan.testSeries];
      const newTests:any = [];
      const { courseDetails } = packageData;
      const courseId = _.map(courseDetails, 'courseId').join(',');
      testDetails.forEach((testDetail: TestDetail) => {
        let testId = _.get(testDetail, 'testId');
        const questionCountFromAPI = this.getQuestionCount(testDetail, validTests)
        
        let maxAttempts = _.get(testDetail, 'maxAttempts');
        let questionsCount = testNameIdMap[testId] ? questionCountFromAPI : _.get(testDetail, 'questionsCount');
        
        if (testNameIdMap[testId]) {
          testId = testNameIdMap[testId];
        } else {
          testId = '000000000000000000000000';
        }

        let newTestDetail = {
          ...testDetail,
           testId,
           courseId,
           maxAttempts,
           questionsCount,
           startDate: convertDateToUTC(new Date(testDetail.startDate)).toString(),
           endDate: testDetail.endDate ? convertDateToUTC(new Date(testDetail.endDate)).toString() : '',
           
         } 
        newTestSeries.push(newTestDetail);
        newTests.push(newTestDetail)
      });
      newCoursePlan.testSeries = newTestSeries;
      newCoursePlan.totalTests = newCoursePlan.testSeries.length;

      // TEST SERIES SHOULD NOT BE SET HERE - Rittick
      // this.props.setTestSeries(newTestSeries);
      
      const { duplicateExists, duplicateTestData } = checkForDuplicateTests(coursePlan.phases , newTests)
      const isAnyTestInSheetDuplicate = checkForDuplicateTestsWithinSheet(newTests);


      if(!duplicateExists && !isAnyTestInSheetDuplicate) {
        this.setState(
          {
            activeRadio,
          },
          () => {
            this.props.setBulkUploadTestData({
              testData: newTests,
              testType: activeRadio,
            });
          }
        ); // Setting active radio in state, based on this insert the tests
      } else {

        if(isAnyTestInSheetDuplicate){
          this.props.showMsg('Duplicate test in sheet.', 'error')
        }

        if(duplicateExists) {
          this.props.showMsg('Test already exists in the course', 'error')
        }

      }
    } else {
      const sheetResponse: any = [];
      const testNameMap: any = {};
      inValidTests.forEach((test: any) => {
        if (test.type === 'combined') {
          test.type = 'half course';
        }
        const { testId } = test;
        testNameMap[testId] = test;
        sheetResponse.push(test);
      });

      // testDetails.forEach((testDetail: any) => {
      //   let testId = _.get(testDetail, 'testId');
      //   if (testNameMap[testId]) {
      //     testDetail.errorMessage = testNameMap[testId].errorMessage;
      //   }
      //   sheetResponse.push(testDetail);
      // });
      createErrorSheet(sheetResponse, 'ScheduleTestSheet.xlsx');
    }
  };

  handleAddExistingTest = (testSeries: any[], activeRadio: any) => {
    const { treeData: coursePlan } = this.props;
    const { duplicateExists } = checkForDuplicateTests(coursePlan.phases , testSeries)
    if(duplicateExists){
      this.props.showMsg('Test already exists in the course', 'error');
    }
    const newCoursePlan = { ...coursePlan };
    let newTestSeries = [...newCoursePlan.testSeries];
    let newTests = [];
    let combinedtestSeries = [];
    combinedtestSeries.push(...newTestSeries, ...testSeries);
    newTests.push(...testSeries)
    newCoursePlan.testSeries = combinedtestSeries;
    newCoursePlan.totalTests = combinedtestSeries.length;
    this.props.setBulkUploadTestData({
      testData: newTests,
      testType: activeRadio,
    });
  };

  handleASTButton = () => {
    this.setState({ openAST: !this.state.openAST });
  };

  handleContentSelectAll = (selectedQuestion: any, totalCount?: number) => {
    this.handleContentSelectFromLibrary(selectedQuestion, totalCount)
  }
  handleInitialState = () => {
    const { filterSelectedQuestion = [] } = this.props;
    this.setState({
      tempQuestions: [],
      selectedQuestionCount: 0,
      selectedQuestion: []
    })
  }

  updateContentTypeValue = (e: any) => {
    let selectedContentType = e;
    this.setState({ selectedContentType })
  }

  destinationWeekHandler = (data: any) => {
    const { phase: destinationPhase, week: destinationWeek } = data;
    // 1. Set destination in state
    this.setState({
      destinationWeek: {
        phase: destinationPhase,
        week: destinationWeek
      }
    })
    
  }

  moveChapter = () => {
    const {
      treeData,
      setTreeData
    } = this.props;
    const {
      destinationWeek,
      dataToMove,
      onlyMovingChapters,
      onlyMovingConcepts,
      movingChaptersAndConcepts
    } = this.state

    const data = this.getDataByKeys(dataToMove);


    const updatedTreeData = this.moveContent(treeData, data, onlyMovingChapters, onlyMovingConcepts, movingChaptersAndConcepts, destinationWeek);

    // Call redux store action here 
    
    // setTreeData(updatedTreeData);

    this.toggleOpenMoveToDialog();
    this.setState({
      showFooterMoveBtn: false
    })
  }

  moveConceptsInBulkNew = (treeData: any,addData: any, destinationWeek: any, conceptsData: any) => {
    const {
      phase,
      week
    } = destinationWeek
    const phaseNumber = +phase;
    const weekNumber = +week;
    const {
      chapter,
      concept
    } = addData;

    conceptsData.map((concept:any) => {
      const { addData } = concept;  
      const { concept: conceptObj } = addData;
      return conceptObj.id
    });
    const { moveData , showMsg, setBulkDrag, resetBulkDrag } = this.props;
    let updatedTreeData = JSON.parse(JSON.stringify(treeData));
    conceptsData.sort((c1: any, c2: any) => {
      const {
        phaseIndex: c1p,
        weekIndex: c1w,
        subjectIndex: c1s,
        chapterIndex: c1ch,
        conceptIndex: c1co
      } = c1.removeDataAt;
      const {
        phaseIndex: c2p,
        weekIndex: c2w,
        subjectIndex: c2s,
        chapterIndex: c2ch,
        conceptIndex: c2co,
      } = c2.removeDataAt;
      const c1Sequence = Number('' + c1p + c1w + c1s + c1ch + c1co);
      const c2Sequence = Number('' + c2p + c2w + c2s + c2ch + c2co);
      return c2Sequence - c1Sequence;
    })
    const conceptIds = conceptsData.map((concept:any) => {
      const { addData } = concept;  
      const { concept: conceptObj, chapter } = addData;
      return conceptObj.id
    });
    conceptsData.forEach((conceptData:any) => {
      const {
        addData,
        removeDataAt
      } = conceptData;
      const {
        phaseIndex,
        weekIndex,
        subjectIndex,
        chapterIndex,
        conceptIndex
      } = removeDataAt;  
      const conceptToRemove = updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts[conceptIndex]
      let concepts = updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts;
      concepts = concepts.filter((concept:any) => concept.id !== conceptToRemove.id);
      updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts = concepts;
      
      const chapter = addData.chapter;
      const relevantConcepts = chapter.concepts.filter((concept:any) => {
        if([...conceptIds].includes(concept.id)) return concept;
      })
      
      let chapters = [...updatedTreeData.phases[phaseNumber].weeks[weekNumber].subjects[subjectIndex].chapters];
      const existingChapter = chapters.find((ch:any) => ch.id === chapter.id);
      const existingChapterIndex = chapters.findIndex((ch:any) => ch.id === chapter.id);
  
      if(existingChapter){
        let updatedChapter = {...existingChapter};
        relevantConcepts.forEach((relevantConcept: any) => {
          const isAlreadyAdded = updatedChapter.concepts.map((el : any) => el.id).includes(relevantConcept.id);
          if(!isAlreadyAdded) {
            updatedChapter.concepts.push(relevantConcept); 
          }
        });
        chapters[existingChapterIndex] = updatedChapter;
      } else {
        let updatedChapter = {...chapter};
        updatedChapter.concepts = relevantConcepts;
        chapters.push(updatedChapter)
      }
    let updatedSubjects = [...updatedTreeData.phases[phaseNumber].weeks[weekNumber].subjects];
    let updatedWeeks = [...updatedTreeData.phases[phaseNumber].weeks]
    let updatedPhases = [...updatedTreeData.phases]

    updatedSubjects[subjectIndex].chapters = chapters;
    updatedWeeks[weekNumber].subjects = updatedSubjects;
    updatedPhases[phaseNumber].weeks = updatedWeeks;
    updatedTreeData.phases = updatedPhases;
    });
    
  

    updatedTreeData = isLastInstanceOfChapter(updatedTreeData, addData);


    moveData(updatedTreeData);
    showMsg('Content Moved Successfully', 'success');
    resetBulkDrag();
  }

  moveContent = (treeData:any, data:any, onlyChapters: boolean, onlyConcepts: boolean, chaptersAndConcepts: boolean, destinationWeek: any) => {
    let updatedTreeData = JSON.parse(JSON.stringify(treeData));
    if(onlyChapters){
      const { chapters } = data;
      this.moveChaptersInBulk(updatedTreeData, chapters, destinationWeek);
    }

    if(onlyConcepts){
      const { concepts } = data;

      const {
        addData,
        removeDataAt  } = concepts[0];
      // this.moveConceptsInBulk(updatedTreeData, addData, destinationWeek, removeDataAt.subjectIndex, removeDataAt.chapterIndex, concepts)
      // setTimeout(() => {
      //   this.deleteConceptNode(this.props.treeData, removeDataAt)

      // }, 10);
      this.moveConceptsInBulkNew(updatedTreeData,addData, destinationWeek, concepts);
      setTimeout(() => {
          this.setState({
            treeDataForDelete: this.props.treeData
          })
      }, 10)
      // concepts.forEach((concept:any) => {
      //   const {
      //     addData,
      //     removeDataAt  } = concept;

    }

    if(chaptersAndConcepts){
      const { chapters, concepts } = data;
      
      this.moveChaptersInBulk(updatedTreeData, chapters, destinationWeek);
    }

    return updatedTreeData;
  }

  deleteChapterNode = (treeData:any, removeDataAt: any) => {
    const {
      phaseIndex,
      weekIndex,
      subjectIndex,
      chapterIndex,
    } = removeDataAt;
    const { setTreeData,moveData,resetBulkDrag } = this.props;
    // TODO
    const chapterToRemove = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex]; 
    if(!chapterToRemove) {
      return;
    }
    const chapters = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters;
    const chaptersToBeSaved = chapters.filter((chapter:any, index: number) => chapter.id !== chapterToRemove.id);
    let updatedData = JSON.parse(JSON.stringify(treeData))
    if( updatedData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters.length != 0){
      updatedData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters = chaptersToBeSaved;
      setTreeData(updatedData);
      moveData(updatedData);
      resetBulkDrag();
    }
   
  }

  moveChaptersInBulk = (treeData: any, chaptersData: any, destinationWeek: any) => {
    const {
      phase,
      week
    } = destinationWeek;
    const phaseNumber = +phase;
    const weekNumber = +week;
    let updatedTreeData = JSON.parse(JSON.stringify(treeData))
    chaptersData.sort((c1: any, c2: any) => {
      const {
        phaseIndex: c1p,
        weekIndex: c1w,
        subjectIndex: c1s,
        chapterIndex: c1c,
      } = c1.removeDataAt;
      const {
        phaseIndex: c2p,
        weekIndex: c2w,
        subjectIndex: c2s,
        chapterIndex: c2c,
      } = c2.removeDataAt;
      const c1Sequence = Number('' + c1p + c1w + c1s + c1c);
      const c2Sequence = Number('' + c2p + c2w + c2s + c2c);
      return c2Sequence - c1Sequence;
    })
    chaptersData.forEach((chapterData: any) => {
      const {
        addData,
        removeDataAt } = chapterData;
      const {
        phaseIndex,
        weekIndex,
        subjectIndex,
        chapterIndex,
      } = removeDataAt;
      // TODO
      const chapterToRemove = updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex];
      const chaptersInCurrentTree = updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters;
      const chaptersToBeSaved = chaptersInCurrentTree.filter((chapter: any, index: number) => chapter.id !== chapterToRemove.id);
      if (updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters.length != 0) {
        updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters = chaptersToBeSaved;
      }
      let chapters = [...updatedTreeData.phases[phaseNumber].weeks[weekNumber].subjects[subjectIndex].chapters];
      const chapterDataIndex = chapters.findIndex(chapter => chapter.id === addData.id);
      if(chapterDataIndex !== -1) {
        chapters[chapterDataIndex].concepts.push(...addData.concepts);
        chapters[chapterDataIndex].content.push(...addData.content);
      } else {
        chapters.push(addData);
      }
      let updatedSubjects = [...updatedTreeData.phases[phaseNumber].weeks[weekNumber].subjects];
      let updatedWeeks = [...updatedTreeData.phases[phaseNumber].weeks]
      let updatedPhases = [...updatedTreeData.phases]

      updatedSubjects[subjectIndex].chapters = chapters;
      updatedWeeks[weekNumber].subjects = updatedSubjects;
      updatedPhases[phaseNumber].weeks = updatedWeeks;
      updatedTreeData.phases = updatedPhases;
      updatedTreeData = isLastInstanceOfChapter(updatedTreeData, addData);
    });
    const { setTreeData, moveData, showMsg, setBulkDrag, resetBulkDrag } = this.props;
    setTreeData(updatedTreeData);
    moveData(updatedTreeData);
    showMsg('Content Successfully Moved', 'success')
    resetBulkDrag();
  }

  moveChapterNode = (treeData:any, addData:any, destinationWeek:any, removeDataAt: any) => {
    const {
      phase,
      week
    } = destinationWeek
    const { setTreeData, moveData, showMsg, setBulkDrag, resetBulkDrag } = this.props;
    const phaseNumber = +phase;
    const weekNumber = +week;
    let updatedTreeData = JSON.parse(JSON.stringify(treeData))
    // delete node
    const {
      phaseIndex,
      weekIndex,
      subjectIndex,
      chapterIndex,
    } = removeDataAt;
    // TODO
    const chapterToRemove = updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex]; 
    if(!chapterToRemove) {
      return;
    }
    const chaptersInCurrentTree = updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters;
    const chaptersToBeSaved = chaptersInCurrentTree.filter((chapter:any, index: number) => chapter.id !== chapterToRemove.id);
    if( updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters.length != 0){
      updatedTreeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters = chaptersToBeSaved;
    }
    // add node
    // TODO
    let chapters = [...treeData.phases[phaseNumber].weeks[weekNumber].subjects[subjectIndex].chapters];
    chapters.push(addData);

    let updatedSubjects = [...updatedTreeData.phases[phaseNumber].weeks[weekNumber].subjects];
    let updatedWeeks = [...updatedTreeData.phases[phaseNumber].weeks]
    let updatedPhases = [...updatedTreeData.phases]

    updatedSubjects[subjectIndex].chapters = chapters;
    updatedWeeks[weekNumber].subjects = updatedSubjects;
    updatedPhases[phaseNumber].weeks = updatedWeeks;
    updatedTreeData.phases = updatedPhases;
    setTreeData(updatedTreeData);
    moveData(updatedTreeData);
    showMsg('Content Successfully Moved', 'success')
    resetBulkDrag();
  }


  deleteConceptNode = (treeData:any, removeDataAt:any) => {
    const {
      phaseIndex,
      weekIndex,
      subjectIndex,
      chapterIndex,
      conceptIndex
    } = removeDataAt;
    const { setTreeData, moveData } = this.props;

    const conceptToRemove = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts[conceptIndex]
    let concepts = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts;
    concepts = concepts.filter((concept:any) => concept.id !== conceptToRemove.id);
    let updatedData: any = JSON.parse(JSON.stringify(treeData))

    updatedData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts = concepts;
    moveData(updatedData);
  }

  moveConceptNode = (treeData:any, addData:any, destinationWeek:any, subjectIndex: any, chapterIndex: any) => {
    const {
      phase,
      week
    } = destinationWeek
    const phaseNumber = +phase;
    const weekNumber = +week;
    const { moveData , showMsg, setBulkDrag, resetBulkDrag } = this.props;
    const {
      chapter,
      concept
    } = addData;

    let concepts = chapter.concepts.filter((conceptData:any) => conceptData.id === concept.id);
    
    let chapters = [...treeData.phases[phaseNumber].weeks[weekNumber].subjects[subjectIndex].chapters];
    const existingChapter = chapters.find((ch:any) => ch.id === chapter.id);
    const existingChapterIndex = chapters.findIndex((ch:any) => ch.id === chapter.id);
    
    
    if(existingChapter){
      let updatedChapter = {...existingChapter};
      let updatedConcepts = [...updatedChapter.concepts, concepts];
      updatedChapter.concepts = updatedConcepts;
      chapters[existingChapterIndex] = updatedChapter;
    } else {
      let updatedChapter = {...chapter};
      updatedChapter.concepts = concepts;
      chapters.push(updatedChapter)
    }

    let updatedTreeData = JSON.parse(JSON.stringify(treeData))
    let updatedSubjects = [...updatedTreeData.phases[phaseNumber].weeks[weekNumber].subjects];
    let updatedWeeks = [...updatedTreeData.phases[phaseNumber].weeks]
    let updatedPhases = [...updatedTreeData.phases]

    updatedSubjects[subjectIndex].chapters = chapters;
    updatedWeeks[weekNumber].subjects = updatedSubjects;
    updatedPhases[phaseNumber].weeks = updatedWeeks;
    updatedTreeData.phases = updatedPhases;
    updatedTreeData = isLastInstanceOfChapter(updatedTreeData, addData);
    moveData(updatedTreeData);
    showMsg('Content Moved Successfully', 'success');
    resetBulkDrag();
  }

  moveConceptsInBulk = (treeData:any, addData:any, destinationWeek:any, subjectIndex: any, chapterIndex: any, concepts:any) => {
    const {
      phase,
      week
    } = destinationWeek
    const phaseNumber = +phase;
    const weekNumber = +week;
    const { moveData , showMsg, setBulkDrag, resetBulkDrag } = this.props;
    const {
      chapter,
      concept
    } = addData;

    const conceptIds = concepts.map((concept:any) => {
      const { addData } = concept;  
      const { concept: conceptObj } = addData;
      return conceptObj.id
    });
    

    const relevantConcepts = chapter.concepts.filter((concept:any) => {
      if([...conceptIds].includes(concept.id)) return concept;
    })
    
    let chapters = [...treeData.phases[phaseNumber].weeks[weekNumber].subjects[subjectIndex].chapters];
    const existingChapter = chapters.find((ch:any) => ch.id === chapter.id);
    const existingChapterIndex = chapters.findIndex((ch:any) => ch.id === chapter.id);

    if(existingChapter){
      let updatedChapter = {...existingChapter};
      let updatedConcepts = [...updatedChapter.concepts, ...relevantConcepts];
      updatedChapter.concepts = updatedConcepts;
      chapters[existingChapterIndex] = updatedChapter;
    } else {
      let updatedChapter = {...chapter};
      updatedChapter.concepts = relevantConcepts;
      chapters.push(updatedChapter)
    }

    let updatedTreeData = JSON.parse(JSON.stringify(treeData))
    let updatedSubjects = [...updatedTreeData.phases[phaseNumber].weeks[weekNumber].subjects];
    let updatedWeeks = [...updatedTreeData.phases[phaseNumber].weeks]
    let updatedPhases = [...updatedTreeData.phases]

    updatedSubjects[subjectIndex].chapters = chapters;
    updatedWeeks[weekNumber].subjects = updatedSubjects;
    updatedPhases[phaseNumber].weeks = updatedWeeks;
    updatedTreeData.phases = updatedPhases;
    updatedTreeData = isLastInstanceOfChapter(updatedTreeData, addData);
    moveData(updatedTreeData);
    showMsg('Content Moved Successfully', 'success');
    resetBulkDrag();
  }

  getDataByKeys = (keys:any) => {
    const { treeData } = this.props;
    let data:any = {
      chapters: [],
      concepts: []
    }

    for(let i = 0; i < keys.length; i++){
      const key = keys[i];
      const keyData = key.split('-').filter((key:any) => key !== '-')
      if(keyData[0] === 'chapter'){
        const phaseIndex = +keyData[1];
        const weekIndex = +keyData[2];
        const subjectIndex = +keyData[3];
        let chapterIndex = +keyData[4];

        const chapter = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex];

        data.chapters.push({
          addData: chapter,
          removeDataAt: {
            phaseIndex,
            weekIndex,
            subjectIndex,
            chapterIndex,
          }
        });
      }

      if(keyData[0] === 'concept'){
        const phaseIndex = +keyData[1];
        const weekIndex = +keyData[2];
        const subjectIndex = +keyData[3];
        const chapterIndex = +keyData[4];
        const conceptIndex = +keyData[5];

         const chapter = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex]
       if( treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex] != undefined){
          const concept = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts[conceptIndex]
          const conceptData = {
            chapter: chapter,
            concept: concept
          }
          data.concepts.push({
            addData: conceptData,
            removeDataAt: {
              phaseIndex,
              weekIndex,
              subjectIndex,
              chapterIndex,
              conceptIndex
            }
          });
       }
       

       
      }
    }

    return data;
  }

  deleteChapterConcept=()=>{
    const {treeData} = this.props;
    const { dataToMove,onlyMovingChapters,onlyMovingConcepts,movingChaptersAndConcepts,destinationWeek,openDeleteDialog } = this.state
    let updatedTreeData = JSON.parse(JSON.stringify(treeData))

    const data = this.getDataByKeys(dataToMove);
    const { chapters,concepts } = data;
    chapters.sort((c1: any, c2: any) => {
      const {
        phaseIndex: c1p,
        weekIndex: c1w,
        subjectIndex: c1s,
        chapterIndex: c1c,
      } = c1.removeDataAt;
      const {
        phaseIndex: c2p,
        weekIndex: c2w,
        subjectIndex: c2s,
        chapterIndex: c2c,
      } = c2.removeDataAt;
      const c1Sequence = Number('' + c1p + c1w + c1s + c1c);
      const c2Sequence = Number('' + c2p + c2w + c2s + c2c);
      return c2Sequence - c1Sequence;
    })
    if(onlyMovingChapters){

     chapters.forEach((chapter:any) => {
      const { addData, removeDataAt } = chapter;
      this.deleteChapterNode(this.props.treeData,removeDataAt)
      })
    }
    if(onlyMovingConcepts){
       concepts.forEach((concepts:any) => {
      const { addData, removeDataAt } = concepts;
      setTimeout(() => {
        this.deleteConcept(this.props.treeData,removeDataAt)

      }, 10)
      })
      setTimeout(() => {
        this.setState({
          treeDataForDelete: this.props.treeData
        })
      }, 10)


    }
    if(movingChaptersAndConcepts){
      for(let i=0; i< chapters.length; i++) {

        const { 
          addData,
          removeDataAt } = chapters[i];
        setTimeout(() => {
          this.deleteChapterNode(this.props.treeData, removeDataAt)
        }, 10)

      }
      setTimeout(() => {
        this.setState({
          treeDataForDelete: this.props.treeData
        })
      }, 10)
    }
   
    this.setState({
      openDeleteDialog:!openDeleteDialog
    })
   
  }

  deleteChapter=(data:any,removeDataAt:any)=>{
    const {
      phaseIndex,
      weekIndex,
      subjectIndex,
      chapterIndex,
    } = removeDataAt;
    const { setTreeData,moveData,resetBulkDrag } = this.props;
    // TODO
    const chapterToRemove = data.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex]; 
     let chapters = data.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters;
     chapters = chapters.filter((chapter:any, index: number) => chapter.id !== chapterToRemove.id);
      data.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters = chapters;
     
     
   setTreeData(data);
   moveData(data);
   resetBulkDrag();

  }

  deleteConcept=(data:any,removeDataAt:any)=>{
    const {
      phaseIndex,
      weekIndex,
      subjectIndex,
      chapterIndex,
      conceptIndex
    } = removeDataAt;
    const { setTreeData,moveData,resetBulkDrag } = this.props;

    const conceptToRemove = this.state.treeDataForDelete.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts[conceptIndex]
    let concepts = data.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts;
    concepts = concepts.filter((concept:any) => concept.id !== conceptToRemove.id);

    let updatedData: any = JSON.parse(JSON.stringify(data))
    updatedData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex].concepts = concepts;
    moveData(updatedData);
    resetBulkDrag();
  }
  handleCourseSettingBtn = () => {
    const { openRequestPop } = this.state;
    //add code
    this.setState({
      openRequestPop: !openRequestPop
    });
  };
  
  render = () => {
    const { structure = [], handleCourseComponent, treeData, getPackageByIdData: packageData, includesScheduledTests } = this.props;
    const { startDate, endDate, subjects, totalPhases } = treeData;
    const { selectedQuestionCount, openMyLibrary, preFilters, templates, showBulkTestPopUp, loading, selectedContentType,dataToMove } = this.state;
    const { subjectSelection, openMoveToDialog, showFooterMoveBtn,openDeleteDialog } = this.state;
    const hasValidSubjects = subjects && subjects.length;
    const { startDate:packageStartDate, expiryDate: packageExpiryDate} = packageData;
    const { classes } = this.props;
    let updatedTreeData = JSON.parse(JSON.stringify(treeData))
    const data = this.getDataByKeys(dataToMove);
    const { openRequestPop} = this.state;
    const showTestVisibility=_.get(treeData,"displaySettings.showTestVisibility",false);
  
    return loading ? (
      <Spinner />
    ) : (
      <>
        <div className="course-plan">
          <div className="course-plan-heading">
            <span>
              <h4 className="coursePlanHeading">Course Plan&nbsp;<img src='/assets/svg/setting-icon.svg' onClick={this.handleCourseSettingBtn.bind(this)}/></h4>
              <p className="dateRange">
                {getFormattedDates(packageStartDate, packageExpiryDate)}
              </p>
            </span>
           
                  <span>
                    {/* <Button
                      variant="contained"
                      color="primary"
                    >
                      Setting
                    </Button> */}

                    {openRequestPop && (
                      <CourseSettingPopUp
                        open={openRequestPop}
                        onClose={this.handleCourseSettingBtn}
                      />
                    )}
                  </span>
            <div style={{ display: "flex", alignItems: "center" }}>
              {!this.props.fromCombo && includesScheduledTests && (
                <AddScheduledTestPopUp
                  open={showBulkTestPopUp}
                  templates={templates}
                  onClose={this.handleBulkTestBttn}
                  onDone={this.handleAddTests}
                  addExistingTest={this.handleAddExistingTest}
                />
              )}
              {this.props.fromCombo && includesScheduledTests && (
                <>
                  <span
                    className={classes.customFileBrowse}
                    style={{ marginTop: "0px" }}
                    onClick={this.handleASTButton}
                  >
                    <label
                      className={
                        showFooterMoveBtn
                          ? classes.customDisabled
                          : [classes.linkCTA, classes.mb18].join(" ")
                      }
                    >
                      <CloudUploadOutlinedIcon />
                      &nbsp; Add Scheduled Tests
                    </label>
                  </span>
                  <AddScheduledTest
                    open={this.state.openAST}
                    onClose={this.handleASTButton}
                    packageId={packageData._id}
                  />
                </>
              )}
              <Tooltip
                title="Add content from the selected goal(s)"
                placement="bottom-end"
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.toggleMyLibraryData}
                  disabled={showFooterMoveBtn}
                >
                  Add Content
                </Button>
              </Tooltip>
            </div>
            {Boolean(Object.keys(preFilters).length) && openMyLibrary && (
              <AddContent
                openMyLibary={openMyLibrary}
                selectedContentType={selectedContentType}
                type="studyMaterial"
                selectedQuestionCount={selectedQuestionCount}
                handleBackToComponent={this.toggleMyLibraryData}
                handleContentSelect={this.handleContentSelectFromLibrary}
                handleInitialState={this.handleInitialState}
                isSelectAllRequired={true}
                preSelectedFilterContent={preFilters}
                handleAddContent={this.handleAddContentFromLibrary}
                isCourse={true}
                handleContentSelectAll={this.handleContentSelectAll}
                getAllSelectCount={this.getAllSelectCount}
                updateContentTypeValueParent={this.updateContentTypeValue}
                // filterContent={this.props.filterSelectedQuestion}
                // selectedQuestion={this.state.selectedQuestion}
                // onCheckContentExist={this.onCheckContentExist}
                // preSelectedFilterContent={
                //   Boolean(Object.keys(preFilters).length) &&
                //   preFilters[`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`]
                // }
              />
            )}
          </div>
          <div />
          <div
            style={{
              borderBottom: "1px solid lightgrey",
              padding: "0 20px 20px",
            }}
            className={classes.abc}
          >
            <ul style={{ display: "flex", listStyle: "none" }}>
              <li
                key="All Subjects"
                className={
                  this.state.subjectSelection === "All Subjects"
                    ? classes.activeTab
                    : classes.subTabs
                }
                onClick={() =>
                  this.setState({ subjectSelection: "All Subjects" })
                }
              >
                All Subjects
              </li>
              {hasValidSubjects &&
                subjects.map(
                  (subject: { name: string; chapterCount: number }) => (
                    <li
                      className={
                        this.state.subjectSelection === subject.name
                          ? classes.activeTab
                          : classes.subTabs
                      }
                      key={subject.name}
                      onClick={() =>
                        this.setState({ subjectSelection: subject.name })
                      }
                    >
                      {subject.name}
                    </li>
                  )
                )}
            </ul>
          </div>
          <div>
            {structure.map((phase: any, phaseIndex: number) => {
              if (
                subjectSelection === "All Subjects" ||
                phase.subjects.filter(
                  (subject: any) =>
                    subject.name === subjectSelection &&
                    subject.chapterCount > 0
                ).length
              ) {
                return (
                  <>
                    <TreeLevel
                      subjectTab={subjectSelection}
                      key={phase.name}
                      treeNode={phase}
                      level={1}
                      handleCourseComponent={handleCourseComponent}
                      fromCombo={this.props.fromCombo}
                      phaseIndex={phaseIndex}
                      mappedConceptsAndChapter={this.state.mappedConceptsAndChapter}
                      childIndex={phaseIndex}
                      treeData={treeData}
                    />

                    {phase.extraTests && phase.extraTests.length > 0 ? (
                      phase.extraTests.map(
                        (test: any, indexOfTest: number) => (
                          <TestComponent
                            phase={phase}
                            test={test}
                            isConflict={test.conflict || false}
                            fromCombo={this.props.fromCombo}
                            courseName={
                              packageData.courseDetails[0].courseType.name
                            }
                            testIndex={indexOfTest}
                            testType="week"
                            isExtraTests={true}
                            phaseIndex={phaseIndex}
                            showTestVisibility={showTestVisibility}
                          />
                        )
                      )
                    ) : (
                      <></>
                    )}
                    {includesScheduledTests &&
                    phase.milestoneTests.length ? (
                      phase.milestoneTests.map(
                        (test: any, indexOfTest: number) => (
                          <TestComponent
                            phase={phase}
                            test={test}
                            isConflict={test.conflict || false}
                            fromCombo={this.props.fromCombo}
                            courseName={
                              packageData.courseDetails[0].courseType.name
                            }
                            testIndex={indexOfTest}
                            isExtraTests={false}
                            phaseIndex={phaseIndex}
                            testType="phase"
                            showTestVisibility={showTestVisibility}
                          />
                        )
                      )
                    ) : includesScheduledTests ? (
                      <TestComponent
                        isEmpty={true}
                        phase={phase}
                        fromCombo={this.props.fromCombo}
                        isExtraTests={false}
                        phaseIndex={phaseIndex}
                        testType="phase"
                        showTestVisibility={showTestVisibility}
                      />
                    ) : (
                      <></>
                    )}
                    {phase.phaseIndex + 1 === totalPhases ? (
                      <AddNewMilestone data={phase} atBottom={true} />
                    ) : (
                      <></>
                    )}
                  </>
                );
              }
              return <></>;
            })}
          </div>
          {/* showing concept or chapter popup */}
          <MyPATDialog
            dialogOpen={this.state.showConceptChapterPopup}
            dialogHeading={"Add Content"}
            otherDialogProps={{
              fullWidth: true,
              maxWidth: "sm",
            }}
            customDialogActions={
              <>
                <Button color="primary" onClick={this.toggleMyLibraryData}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.finalSelection}
                >
                  Next
                </Button>
              </>
            }
          >
            <Typography
              variant="h4"
              style={{
                textAlign: "center",
                color: "#666",
                margin: "0 0 15px",
                fontSize: "18px",
              }}
            >
              Select a level at which you want to add the content
            </Typography>
            <Typography variant="body1" style={{ textAlign: "center" }}>
              <span style={{ marginRight: 10 }}>
                <input
                  type="radio"
                  name="Chapter"
                  value={"chapter"}
                  checked={this.state.selectedContentType === "chapter"}
                  onChange={this.onRadioButtonChange}
                />
                Chapter
              </span>
              <span>
                <input
                  type="radio"
                  name="Concept"
                  value={"concept"}
                  checked={this.state.selectedContentType === "concept"}
                  onChange={this.onRadioButtonChange}
                />
                Concept
              </span>
            </Typography>
          </MyPATDialog>
          {/* showing concept or chapter popup ends */}

          {/* Footer Bar for Move Btn */}

          {showFooterMoveBtn && (
            <div className={classes.footerBottomFixed}>
              <div className={classes.buttonGroup}>
                <button
                  className={classes.removeBtn}
                  onClick={this.toggleOpenDeleteToDialog}
                  disabled={this.checkForDuplicateCourse()}
                >
                  Delete
                </button>
                <button
                  className={classes.moveBtn}
                  onClick={this.toggleOpenMoveToDialog}
                >
                  Move
                </button>
              </div>
            </div>
          )}

          <MyPATDialog
            dialogOpen={openDeleteDialog}
            onDialogClose={() => this.toggleOpenDeleteToDialog()}
            otherDialogProps={{
              fullWidth: true,
              maxWidth: "sm",
            }}
            // customDialogActions={
            //   <div>
            //     <Button onClick={this.deleteChapterConcept}>Yes</Button>
            //     <Button
            //       className={classes.moveBtn}
            //       onClick={this.toggleOpenDeleteToDialog}
            //     >
            //       No
            //     </Button>
            //   </div>
            // }
          >
            <Grid container className={classes.widthSM}                  
                 direction="column"
                 justify="center"
                 alignItems="center"
                //  alignContent="space-between
                style={{marginTop: '-20px', textAlign: 'center'}}>
              <Grid xs={12}>
              <img src='/assets/svg/delete-icon.svg' />
              <Typography align="center" style={{fontSize: '1.6rem', fontWeight: 'bold', margin: '10px 0'}}>
                  {/* classes={{ root: classes.overrideText }} */}
                
                  Remove Syllabus Items
                </Typography>
                <Typography align="center" style={{fontSize: '1rem', color: '#666',margin: '5px 0 25px 0'}}>
                  {/* variant="body1"
                  align="center"
                  classes={{ root: classes.overrideText }}
                > */}
                  You will Not be able to add these concepts/chapters later.{" "}
                  <br />
                  Arey you sure you want to permenently <br />
                  remove these syllabus item?
                </Typography>

                <Grid item xs={12}>
              <Grid
                container
                alignItems="center"
                justify="center"
                style={{ marginBottom: "20px" }}
              >

            <Button style={{color: '#1d7dea'}} onClick={this.deleteChapterConcept}>Yes</Button>
                <Button
                  className={classes.moveBtn}
                  onClick={this.toggleOpenDeleteToDialog}
                >
                  No
                </Button>

              </Grid>
            </Grid>
              </Grid>
            </Grid>


          </MyPATDialog>
          {/* Move Chapter Dialog Starts */}
          <MyPATDialog
            dialogOpen={openMoveToDialog}
            dialogHeading={"Move To"}
            onDialogClose={() => this.toggleOpenMoveToDialog()}
            classes={{ root: classes.scrollFixedHeight }}
            otherDialogProps={{
              fullWidth: true,
              maxWidth: "sm",
            }}
            customDialogActions={
              <div>
                <Button
                  className={classes.moveBtn}
                  onClick={this.moveChapter}
                >
                  Move
                </Button>
              </div>
            }
          >
            <MoveChapter
              treeData={treeData}
              onSelection={this.destinationWeekHandler}
            />
          </MyPATDialog>
        </div>
      </>
    );
  };
}
const mapStateToProps = (state: any) => {
  return {
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
    coursePackageList:  _.get(state, 'courseMangementData.contentManagementData.coursePackageList', []),
    bulkDrag: _.get(state, 'courseMangementData.contentManagementData.bulkDrag', {}),
    getPackageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData.packageData', {}),
    filterSelectedQuestion: _.get(state, 'courseMangementData.contentManagementData.filterSelectedQuestion', []),
    includesScheduledTests: _.get(state, 'courseMangementData.contentManagementData.includesScheduledTests', true)
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setTreeData: contentManagementAction.setTreeData,
      setFilterSelectedQuestion: contentManagementAction.setFilterSelectedQuestion,
      addMilestoneTestInPhase: contentManagementAction.addMilestoneTestInPhase,
      setTestSeries: contentManagementAction.setTestSeries,
      setBulkUploadTestData: contentManagementAction.setBulkUploadTestData,
      showMsg: showMsg,
      setIncludesScheduledTests: contentManagementAction.setIncludesScheduledTests,
      moveData: contentManagementAction.moveData,
      setBulkDrag: contentManagementAction.setBulkDrag,
      resetBulkDrag: contentManagementAction.resetBulkDrag,
      setGoalsDriller:contentManagementAction.setGoalsDriller,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(coursePlanStyle)(CoursePlanTree));